<template>
   <b-modal
    ref="modal"
    title="Thay thế hoá đơn điện tử"
    header-bg-variant="warning"
    header-text-variant="dark"
    @ok="handleSubmit"
    ok-title="Xác nhận thay thế"
    ok-variant="warning"
    cancel-title="Đóng"
    :ok-disabled="isSubmitting"
    no-close-on-backdrop
    size="lg"
    > <template v-if="invoice"
      > <!-- Warning -->
      <div class="alert alert-light-warning border-warning mb-4">

        <div class="d-flex align-items-center mb-2">
           <i class="fas fa-info-circle text-warning mr-2"></i> <strong>Thay thế hoá đơn</strong>
        </div>

        <p
          class="mb-0 text-dark"
          style="font-size: 0.85rem"
        >
           Thao tác này sẽ huỷ hoá đơn gốc và phát hành hoá đơn mới thay thế. Hoá đơn gốc sẽ chuyển
          sang trạng thái "Đã thay thế".
        </p>

      </div>
       <!-- Original invoice info -->
      <div class="bg-light p-3 rounded mb-4">

        <h6 class="font-weight-bold mb-2">
           <i class="fas fa-file-invoice mr-1"></i> Hoá đơn gốc (sẽ bị thay thế)
        </h6>
         <b-row
          > <b-col md="3"
            > <small class="text-muted">Số HĐ</small>
            <div class="font-weight-bold">{{ invoice.invoiceNo || '---' }}</div>
             </b-col
          > <b-col md="3"
            > <small class="text-muted">Ngày HĐ</small>
            <div>{{ formatInvoiceDateShort(invoice.invoiceDate) }}</div>
             </b-col
          > <b-col md="3"
            > <small class="text-muted">Khách hàng</small>
            <div>{{ invoice.buyerName || 'Khách lẻ' }}</div>
             </b-col
          > <b-col md="3"
            > <small class="text-muted">Tổng tiền</small>
            <div class="font-weight-bold"> {{ formatCurrency(invoice.totalAmount) }} </div>
             </b-col
          > </b-row
        >
      </div>
       <!-- Reason --> <b-form-group
        label="Lý do thay thế *"
        label-class="font-weight-bold"
        :invalid-feedback="reasonError"
        :state="reasonState"
        > <b-form-textarea
          v-model="form.reason"
          rows="2"
          placeholder="Nhập lý do thay thế..."
          :state="reasonState"
          @input="$v.form.reason.$touch()"
        ></b-form-textarea
        > </b-form-group
      > <!-- New buyer info (optional override) -->
      <h6 class="font-weight-bold mt-4 mb-3">
         Thông tin hoá đơn thay thế <small class="text-muted font-weight-normal"
          >(để trống nếu giữ nguyên)</small
        >
      </h6>
       <b-row
        > <b-col md="6"
          > <b-form-group
            label="Tên khách hàng"
            label-class="font-weight-bold"
            > <b-form-input
              v-model="form.newBuyerName"
              size="sm"
              :placeholder="invoice.buyerName || 'Tên mới'"
            ></b-form-input
            > </b-form-group
          > </b-col
        > <b-col md="6"
          > <b-form-group
            label="MST khách"
            label-class="font-weight-bold"
            > <b-form-input
              v-model="form.newBuyerTaxCode"
              size="sm"
              :placeholder="invoice.buyerTaxCode || 'MST mới'"
            ></b-form-input
            > </b-form-group
          > </b-col
        > <b-col md="12"
          > <b-form-group
            label="Địa chỉ"
            label-class="font-weight-bold"
            > <b-form-input
              v-model="form.newBuyerAddress"
              size="sm"
              :placeholder="invoice.buyerAddress || 'Địa chỉ mới'"
            ></b-form-input
            > </b-form-group
          > </b-col
        > </b-row
      > </template
    > <!-- Loading --> <loading-overlay
      :active="isSubmitting"
      :is-full-page="false"
      > <template #default
        >
        <div class="text-center">
           <b-spinner variant="warning"></b-spinner>
          <p class="mt-2 text-muted">Đang xử lý thay thế...</p>

        </div>
         </template
      > </loading-overlay
    > </b-modal
  >
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'
  import LoadingOverlay from '@/view/components/common/LoadingOverlay.vue'
  import { EINVOICE_REPLACE } from '@/core/services/store/modules/einvoice/einvoice.module'
  import { getToastInstance } from '@/utils/toastHelper'
  import einvoiceMixin from '../mixins/einvoice.mixin'

  const { makeToastSuccess, makeToastFailure } = getToastInstance()

  export default {
    name: 'EInvoiceReplaceModal',
    components: { LoadingOverlay },
    mixins: [validationMixin, einvoiceMixin],
    props: {
      invoice: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        isSubmitting: false,
        form: {
          reason: '',
          newBuyerName: '',
          newBuyerTaxCode: '',
          newBuyerAddress: '',
        },
      }
    },
    validations: {
      form: {
        reason: { required, minLength: minLength(5) },
      },
    },
    computed: {
      reasonState() {
        const { $dirty, $error } = this.$v.form.reason
        return $dirty ? !$error : null
      },
      reasonError() {
        if (!this.$v.form.reason.required) return 'Vui lòng nhập lý do thay thế'
        if (!this.$v.form.reason.minLength) return 'Lý do phải có ít nhất 5 ký tự'
        return ''
      },
    },
    methods: {
      show() {
        this.resetForm()
        this.$refs.modal.show()
      },
      hide() {
        this.$refs.modal.hide()
      },
      resetForm() {
        this.form = {
          reason: '',
          newBuyerName: '',
          newBuyerTaxCode: '',
          newBuyerAddress: '',
        }
        this.$v.$reset()
      },
      async handleSubmit(bvModalEvt) {
        bvModalEvt.preventDefault()
        this.$v.form.$touch()
        if (this.$v.form.$invalid) return

        this.isSubmitting = true
        try {
          const requestPayload = {
            salesInvoiceId: this.invoice.salesInvoiceId,
            saleType: this.invoice.saleType,
            reason: this.form.reason,
          }
          if (this.form.newBuyerName) requestPayload.buyerName = this.form.newBuyerName
          if (this.form.newBuyerTaxCode) requestPayload.buyerTaxCode = this.form.newBuyerTaxCode
          if (this.form.newBuyerAddress) requestPayload.buyerAddress = this.form.newBuyerAddress

          await this.$store.dispatch(EINVOICE_REPLACE, requestPayload)

          makeToastSuccess('Thay thế hoá đơn thành công')
          this.$emit('replaced')
          this.hide()
        } catch (err) {
          const msg = err?.message || 'Thay thế thất bại'
          makeToastFailure(msg)
        } finally {
          this.isSubmitting = false
        }
      },
    },
  }
</script>

